import { ChevronRight } from 'lucide-react'

import { formatCurrency } from '@ankor-io/common/util/currencies'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui-components/Table'

type WalletTxn = {
  id: string
  date: string
  description: string
  amount: number
  currency?: string
  reference?: string
}

type ConversionsProps = {
  transactions: WalletTxn[]
}

const Conversions = ({ transactions }: ConversionsProps) => {
  return (
    <div className="space-y-6">
      <div className="overflow-x-auto">
        <Table className="max-w-[calc(100vw-3rem)] lg:max-w-[calc(100vw-20rem)]">
          <TableHead>
            <TableRow>
              <TableHeader>Date</TableHeader>
              <TableHeader>Description</TableHeader>
              <TableHeader>Amount</TableHeader>
              <TableHeader>Reference</TableHeader>
              <TableHeader></TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((t) => (
              <TableRow key={t.id}>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{t.date}</TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{t.description}</TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">
                  {formatCurrency(t.amount, t.currency || 'USD')}
                </TableCell>
                <TableCell className="text-sm text-gray-900 dark:text-gray-100">{t.reference || '—'}</TableCell>
                <TableCell className="text-right">
                  <ChevronRight className="size-4 text-gray-500" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default Conversions
